import { SignUp } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/sign-up/")({
	validateSearch: (
		search: Record<string, unknown>,
	): { redirectTo?: string } => ({
		redirectTo:
			typeof search.redirectTo === "string" && search.redirectTo.length > 0
				? search.redirectTo
				: undefined,
	}),
	component: SignUpPage,
});

function SignUpPage() {
	const { redirectTo } = Route.useSearch();
	const forceRedirectUrl = redirectTo;
	const signInUrl = redirectTo
		? `/sign-in?redirectTo=${encodeURIComponent(redirectTo)}`
		: "/sign-in";

	return (
		<div className="min-h-[calc(100vh-200px)] flex items-center justify-center py-12">
			<SignUp
				routing="path"
				path="/sign-up"
				// Keep the default app landing as fallback, but prefer redirectTo when present
				fallbackRedirectUrl="/app/select-organization"
				forceRedirectUrl={forceRedirectUrl}
				// Ensure switching to sign-in inside Clerk UI also preserves redirectTo
				signInUrl={signInUrl}
			/>
		</div>
	);
}
